'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListPartitioner = function (_PureComponent) {
  _inherits(ListPartitioner, _PureComponent);

  function ListPartitioner() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ListPartitioner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ListPartitioner.__proto__ || Object.getPrototypeOf(ListPartitioner)).call.apply(_ref, [this].concat(args))), _this), _this.splitList = function (items, splitter) {
      var listMap = {};

      items.forEach(function (item) {
        var partitioningKey = void 0;

        if (typeof splitter === 'string') {
          partitioningKey = splitter;
        } else {
          partitioningKey = splitter(item);
        }

        if (!listMap[partitioningKey]) {
          listMap[partitioningKey] = [];
        }

        listMap[partitioningKey].push(item);
      });
      return listMap;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ListPartitioner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          categoryRendererCallback = _props.categoryRendererCallback,
          splitter = _props.splitter,
          items = _props.items;


      var splitList = this.splitList(items, splitter);

      return Object.keys(splitList).map(function (groupName) {
        var list = splitList[groupName];
        return categoryRendererCallback(groupName, list);
      });
    }
  }]);

  return ListPartitioner;
}(_react.PureComponent);

ListPartitioner.propTypes = {
  items: _propTypes2.default.array.isRequired,
  splitter: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
  categoryRendererCallback: _propTypes2.default.func.isRequired
};

exports.default = ListPartitioner;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/ListPartitioner.js
// module id = 587
// module chunks = 0